




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Insertion {
    quotation: {
        quotationNumber: string,
    };
}

@Component({ components: { SimpleText } })
export default class QuotationNumber extends Vue {
    @Prop() public insertion!: Insertion;

    public static getNeededFields(): string[] {
        return [
            "insertion.quotation.quotationNumber",
        ];
    }
}
